<template>
    <div class="optpl-templates__container">
        <div class="optpl-templates__group" v-for="group in groups" v-if="this.templatesStore.templateCount || this.$route.params.type">
            <TemplateGroup :group="group" />
        </div>

        <div v-else>
            <NoResults v-if="showNoResults" />
        </div>
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useTemplatesStore } from "../../store/templates"
import TemplateGroup from './TemplateGroup.vue'
import NoResults from './NoResults.vue';

export default {
    components: { TemplateGroup, NoResults },
    props: {
        groups: { type: Array, required: true },
        showNoResults: { type: Boolean, default: true },
    },
    computed: {
        ...mapStores(useTemplatesStore),
    },
}
</script>
